"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BACK_BTN = exports.CONTENT = exports.DEFAULT = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    DEFAULT = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column"
});

exports.DEFAULT = DEFAULT;
var CONTENT = (0, _cxs["default"])({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  paddingTop: "125px"
});
exports.CONTENT = CONTENT;
var BACK_BTN = (0, _cxs["default"])({
  position: "fixed",
  top: "22px",
  left: "30px",
  zIndex: 3
});
exports.BACK_BTN = BACK_BTN;